export default {
  items: [
    /* {
      name: 'Home',
      url: '/',
      icon: 'icon-home',
      class: "nav-title py-0",
    }, */

    {
      title: true,
      name: "Superfluid Insights",
      class: "mt-2"
    },
    // {
    //   name: 'Databases',
    //   url: '/dashboard/database',
    //   icon: 'icon-speedometer',
    //   class: "nav-title py-0",
    // },
    {
      name: 'General Data Insights',
      url: '/dashboard',
      icon: 'icon-speedometer',
      class: "nav-title py-0",
    },

    {
      name: 'Business Insights',
      url: '/business-insights',
      icon: 'fa fa-pie-chart',
      class: "nav-title py-0",
    },
    /* {
      name: 'Customer Insights',
      url: '/customer-insights',
      icon: 'fa fa-pie-chart',
      class: "nav-title py-0",
	  attributes: { "disabled": true },
    },
    
    {
      title: true,
      name: "Custom Insights - User Generated (coming soon)",
    },
    {
      name: 'Historical Reports',
      url: '/historical-reports',
      icon: 'fa fa-history',
      class: "nav-title py-0",
	  attributes: { "disabled": true }
   
    }, */
    // {
    //   beta: 1,
    //   name: 'Custom Reports',
    //   url: '/custom-reports',
    //   icon: 'fa fa-bar-chart',
    //   class: "nav-title py-0",
    // },
    // {
    //   beta: 1,
    //   name: 'API Analytics',
    //   url: '/external-analytics',
    //   icon: 'fa fa-bar-chart',
    //   class: "nav-title py-0",
    // },
    {
      title: true,
      name: "Analytics",
    },
    {
      name: 'Segments',
      url: '/segments',
      icon: 'icon-layers',
      class: "nav-title py-0",
    },
    // {
    //   beta: 1,
    //   name: 'Customer Lists',
    //   url: '/lists',
    //   icon: 'fa fa-list-ol',
    //   class: "nav-title py-0",
    // },
    {
      name: '360 Data View',
      url: '/360',
      icon: 'fa fa-user-plus',
      class: "nav-title py-0",
    },
    {
      title: true,
      name: "Manage",
    },
    {
      name: 'Data + Projects',
      url: '/sources',
      icon: 'fa fa-database',
      class: "nav-title py-0",
    },
    {
      name: 'Plans',
      url: '/plans',
      icon: 'fa fa-folder',
      class: "nav-title py-0",
    },
    {
      name: 'Referral Program',
      url: '/referral',
      icon: 'fa fa-share',
      class: "nav-title py-0",
    },
    {
      name: 'Notifications',
      url: '/monitor',
      icon: 'fa fa-hourglass-start',
      class: "nav-title py-0",
    },
    {
      title: true,
      name: "Account",
    },
    {
      name: 'Logout',
      url: '/logout',
      icon: 'fa fa-power-off',
      class: "nav-title py-0 mb-2",
    },
  ],
};
